export default [
  {
    path: '/goodManage/:media',
    name: 'manageQq',
    component: () => import('@/pages/goodManage/qq/index'),
    meta: {
      store: 'qq',
      spm: 2020,
      commonParams: ['media_type', 'media_id'],
    },
  },
];
